<template>
  <div>
    <Head title="Data Prodi" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/universities">Universitas</Link>
      <span class="text-indigo-400 font-medium">/</span>
      Data Prodi {{ university.nama }}
    </h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <Link v-if="can('write prodi')" class="btn-indigo" :href="`/universities/${university.id}/prodis/create`">
        <span><font-awesome-icon icon="fas fa-plus" class="mr-2" />Tambah</span>
        <span class="hidden md:inline">&nbsp;Prodi</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Nama Prodi</th>
            <th class="pb-4 pt-6 px-6">Kode Prodi</th>
            <th class="pb-4 pt-6 px-6">Jenjang</th>
            <th v-if="can('write prodi')" class="pb-4 pt-6 px-6 border-b">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="prodi in prodis.data" :key="prodi.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t p-4">
              {{ prodi.nama }}
            </td>
            <td class="border-t p-4">
              {{ prodi.kode_prodi || '-' }}
            </td>
            <td class="border-t p-4">
              {{ prodi.jenjang }}
            </td>
            <td v-if="can('write prodi')" class="p-4 w-px border-t">
              <Link class="btn-indigo-sm rounded-l" :href="`/universities/${university.id}/prodis/${prodi.id}/edit`">
                <font-awesome-icon icon="fas fa-pencil" />
              </Link>
              <Link class="btn-red-sm rounded-r" @click.prevent="destroy(prodi.id)">
                <font-awesome-icon icon="fas fa-trash" />
              </Link>
            </td>
          </tr>
          <tr v-if="prodis.data.length === 0">
            <td class="px-6 py-4 border-t" :colspan="can('write prodi') ? 4 : 3">Tidak ada data prodi.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="prodis.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    university: Object,
    prodis: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/universities/${this.university.id}/prodis`, pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    destroy(id) {
      this.$swal.fire({
        title: 'Anda yakin hapus data ini?',
        text: 'Anda tidak akan dapat mengembalikan data yang sudah dihapus!',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(`/universities/${this.university.id}/prodis/${id}`)
        }
      })
    },
  },
}
</script>
